import { useNavigate } from 'react-router-dom';
import OrganisationNavigationQueryParameters from 'shared/constants/organisation-navigation-query-parameters';
import Routes from 'shared/enums/routes';

type OrganisationNavigation = {
  navigateToOrganisationUnit: (organisationUnitId: string) => void;
};

const useOrganisationNavigation = (): OrganisationNavigation => {
  const navigate = useNavigate();

  const navigateToOrganisationUnit = (organisationUnitId: string): void => {
    const searchParameters = new URLSearchParams({
      [OrganisationNavigationQueryParameters.OrganisationUnitId]: organisationUnitId,
    });

    navigate(`${Routes.Organisation}?${searchParameters.toString()}`);
  };

  return { navigateToOrganisationUnit };
};

export default useOrganisationNavigation;
